console = console || {};
console.log = console.log || function () {
};

if (typeof String.prototype.trim !== 'function')
	String.prototype.trim = function () {
		return this.replace(/^\s+|\s+$/g, '');
	};

window.srWidget = window.srWidget || (function (window) {
	'use strict';

	// ---------------------------------------------------------------------------------------------
	// Insert the loading spinner css that should load before everything else.
	function addCriticalStyles() {
		var style = document.createElement('style');
		style.type = 'text/css';
		var css = '.loader,.loader:after{border-radius:50%;width:2em;height:2em;position:absolute;top:0;left:50%;margin:2.8em 0 0 -1.6em}.loader{font-size:10px;text-indent:-9999em;border:.6em solid rgba(135,146,163,.4);border-left-color:#8792A3;transform:translateZ(0);animation:loader 1.1s infinite linear}@keyframes loader{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}';
		style.appendChild(document.createTextNode(css));
		document.getElementsByTagName('head')[0].appendChild(style);
	}

	// ---------------------------------------------------------------------------------------------
	// Inject a CSS file into the DOM and executes 
	// the provided callback function once completed.
	function loadCss(url, callbackFn) {
		var style = document.createElement('link');
		style.rel = 'stylesheet';
		style.href = url;

		var firstLink = document.getElementsByTagName('link')[0];
		if (firstLink)
			document.getElementsByTagName('head')[0].insertBefore(style, document.getElementsByTagName('link')[0]);
		else
			document.getElementsByTagName('head')[0].appendChild(style);

		callbackFn();
	}

	// ---------------------------------------------------------------------------------------------
	// Inject a javascript file into the DOM and executes 
	// the provided callback function once completed.
	function loadScript(url, callbackFn) {
		var script = document.createElement('script');
		script.type = 'text/javascript';

		if (script.readyState) {  //IE
			script.onreadystatechange = function () {
				if (script.readyState === 'loaded' ||
					script.readyState === 'complete') {
					script.onreadystatechange = null;
					callbackFn();
				}
			};
		}
		else {  //Others
			script.onload = function () {
				callbackFn();
			};
		}

		script.src = url;
		document.getElementsByTagName('body')[0].appendChild(script);
	}

	// ---------------------------------------------------------------------------------------------
	// Load all the widget's necessary styles and scripts
	// and then call the callback function.
	function loadWidget(widgetCssPath, widgetJsPath, callbackFn) {
		addCriticalStyles();

		loadCss(widgetCssPath + 'kendo.common.min.css', function () {
			loadCss(widgetCssPath + 'kendo.metro.min.css', function () {
				requirejs.config({
					waitSeconds: 60,
					paths: {
						"jquery": widgetJsPath + 'jquery-1.12.0.min',
						"kendo": widgetJsPath + 'kendo.web.min'
					},
					shims: {
						"kendo": {
							deps: ['jquery']
						}
					}
				});

				if (typeof ($) != 'undefined') {
					requirejs(['kendo'], function (kendo) {
						callbackFn($, kendo);
					});
				}
				else {
					requirejs(['jquery'], function ($) {
						requirejs(['kendo'], function (kendo) {
							callbackFn($, kendo);
						});
					});
				}
			});
		});
	};

	// ---------------------------------------------------------------------------------------------
	// Retrieve the file path from a "script" tag's "src" attribute.
	function getPathFromUrl(url) {
		url = url.split('?')[0];
		var str = url.substr(url.lastIndexOf('/') + 1) + '$';
		return url.replace(new RegExp(str), '');
	}

	// ---------------------------------------------------------------------------------------------
	// Extract the widget's URLs by scanning through the page's script tags.
	function getWidgetPaths() {
		var paths = {
			widgetCssPath: '',
			widgetJsPath: ''
		};

		var scripts = document.getElementsByTagName('script');
		for (var i = 0; i < scripts.length; i++) {
			if (scripts[i].src.indexOf('widget') !== -1) {
				paths.widgetJsPath = getPathFromUrl(scripts[i].src);
				paths.widgetCssPath = paths.widgetJsPath;
				//paths.widgetCssPath = paths.widgetJsPath.replace("\Scripts", "\Content");
			}
		}

		return paths;
	}

	// ---------------------------------------------------------------------------------------------
	function isObject(item) {
		return (item && typeof item === 'object' && !Array.isArray(item));
	}

	// ---------------------------------------------------------------------------------------------
	function mergeDeep(defaults, settings) {
		if (!isObject(defaults) || !isObject(settings))
			return defaults;

		var result = {};

		Object.keys(defaults).forEach(function (key) {
			if (key in settings) {
				if (isObject(defaults[key]))
					result[key] = mergeDeep(defaults[key], settings[key]);
				else
					result[key] = settings[key];
			}
			else
				result[key] = defaults[key];
		});

		return result;
	}

	// ---------------------------------------------------------------------------------------------
	// The object that this plugin exports.
	var widget = function (config) {
		var webWorkerPromise;

		config = config || {};

		//PROD
		var envCompany = 'Ubisoft2';
		var internalOptions = {
			customFieldsIds: {
				hasReferral: '56c252d7e4b0cabf01d19d35',
				isSpeculativeJob: '56c252f0e4b0b526efa7ee6e',
				jobFamily: '56c253e2e4b043c434799771',
				isPrivateJob: '57052375e4b0b49d28299956',
				ou: '56c253c2e4b0cabf01d19d37'
			}
		};

		//TEST
		//var envCompany = "TheVeryFakeCompany";
		//var internalOptions = {
		//    customFieldsIds: {
		//        hasReferral: "55e711eae4b0414f04965352",
		//        isSpeculativeJob: "56138d59e4b0e639b9a05544",
		//        jobFamily: "55e71929e4b0e809ec65a447",
		//        isPrivateJob: "563a0624e4b06f64d5d50fab"
		//    },
		//};

		var defaultOptions = {
			postingsUrl: 'https://api.smartrecruiters.com/v1/companies/' + envCompany + '/postings',
			postingDetailsUrl: 'https://api.smartrecruiters.com/v1/companies/' + envCompany + '/postings/#:id#',
			speculativeUrl: 'https://www.smartrecruiters.com/' + envCompany + '/#:id#/?oga=true',
			postingsPageUrl: 'https://www.smartrecruiters.com/' + envCompany + '/#:id#',
			linkedInRedirectUrl: 'https://www.linkedin.com/shareArticle?title=#:name#&mini=true&source=SmartRecruiters&summary=Ubisoft%20is%20looking%20for%20a%20#:name#%20in%20#:location.city#%2C%20#country#%20#:postingPageUrl#&url=#:postingPageUrl#',
			facebookRedirectUrl: 'https://www.facebook.com/sharer.php?s=100&p[url]=#:postingPageUrl#',
			twitterRedirectUrl: 'https://twitter.com/share?text=Ubisoft%20is%20looking%20for%20a%20#:name#%20in%20#:location.city#%2C%20#:country#&via=SmartRecruiters&url=#:postingPageUrl#',
			mailRedirectUrl: 'mailto:?&subject=Amazing%20HRIS%20Manager&body=Ubisoft%20is%20looking%20for%20a%20#:name#%20in%20#:location.city#%2C%20#:country#%20#:postingPageUrl#',
			applyButtonUrl: 'https://www.smartrecruiters.com/' + envCompany + '/#:id#/?oga=true',
			referAFriendButtonUrl: 'https://www.smartrecruiters.com/referrals-portal/navigation/posting/#:id#',
			language: 'en',
			translation: {
				en: {
					criteria: {
						headerText: 'Filters',
						keywordLabel: 'Keyword',
						keywordPlaceholder: 'Keyword...',
						//departmentLabel: "Department",
						//departmentPlaceholder: "Department...",
						employmentTypeLabel: 'Employment type',
						employmentTypePlaceholder: 'Employment type...',
						departmentLabel: 'Job family',
						departmentPlaceholder: 'Job family...',
						jobFamilyLabel: 'Job family',
						jobFamilyPlaceholder: 'Job family...',
						locationLabel: 'Location',
						locationPlaceholder: 'Location...',
						countryLabel: 'Country',
						countryPlaceholder: 'Country...',
						ouPlaceholder: 'Organisational unit...',
						searchButtonText: 'Search',
						resetFiltersButtonText: 'Reset filters',
						sendCvButtonText: 'Send us your CV',
						createJobAlertButtonText: 'Create Job Alert'
					},
					postingsGrid: {
						headerText: 'Openings',
						jobTitleColumnTitle: 'Job title',
						//departmentColumnTitle: "Department",
						departmentColumnTitle: 'Job family',
						jobFamilyColumnTitle: 'Job family',
						employemntTypeColumnTitle: 'Employment type',
						locationColumnTitle: 'Location',
						hasBonusReferalColumnTitle: 'Has bonus referral',
						jobSingleColumnMobileTitle: 'Positions',
						hasBonusReferalYesLabel: 'Yes',
						gridPagerMessage: {
							display: '{0} - {1} of {2} items',
							empty: 'No items to display',
							page: 'Page',
							of: 'of {0}',
							itemsPerPage: 'items per page',
							first: 'Go to the first page',
							previous: 'Go to the previous page',
							next: 'Go to the next page',
							last: 'Go to the last page',
							refresh: 'Refresh'
						}
					},
					postingDescription: {
						backToSearchButtonText: 'Back to search',
						applyButtonText: "I'm interested",
						referButtonText: 'Refer a friend',
					},
					sendCvPopUp: {
						sendCvDescription: 'You may use this feature to send us your resume/CV without submitting to a specific job',
						sendCvCountryListDescription: 'Select a contry fromm the following list:',
						popUpTitle: 'Send us your CV',
						applyButtonText: 'Apply',
						cancelButtonText: 'Cancel',
					},
					error: {
						noDataMessage: 'Currently no data is available!'
					}
				},
				fr: {
					criteria: {
						headerText: 'Filters',
						keywordLabel: 'Mot-clé',
						keywordPlaceholder: 'Mot-clé...',
						//departmentLabel: "Département",
						//departmentPlaceholder: "Département...",
						employmentTypeLabel: 'Type de contrat',
						employmentTypePlaceholder: 'Type de contrat...',
						departmentLabel: 'Famille de métier',
						departmentPlaceholder: 'Famille de métier...',
						jobFamilyLabel: 'Famille de métier',
						jobFamilyPlaceholder: 'Famille de métier...',
						locationLabel: 'Emplacement',
						locationPlaceholder: 'Emplacement...',
						countryLabel: 'Pays',
						countryPlaceholder: 'Pays...',
						ouPlaceholder: 'Unité organisationnelle...',
						searchButtonText: 'Rechercher',
						resetFiltersButtonText: 'Supprimer les filtres',
						sendCvButtonText: 'Déposez votre CV',
						createJobAlertButtonText: 'Créer une alerte'
					},
					postingsGrid: {
						headerText: "Offres d'emploi",
						jobTitleColumnTitle: 'Titre',
						//departmentColumnTitle: "Département",
						departmentColumnTitle: 'Famille de métier',
						jobFamilyColumnTitle: 'Famille de métier',
						employemntTypeColumnTitle: 'Type de contrat',
						locationColumnTitle: 'Emplacement',
						hasBonusReferalColumnTitle: 'Bonus de cooptation',
						jobSingleColumnMobileTitle: "Offres d'emploi",
						hasBonusReferalYesLabel: 'Oui',
						gridPagerMessage: {
							display: '{0} - {1} de {2} résultats',
							empty: 'Aucun résultat',
							page: 'Page',
							of: 'sur {0}',
							itemsPerPage: 'résultats par page',
							first: 'Première page',
							previous: 'Page précédente',
							next: 'Page suivante',
							last: 'Dernière page',
							refresh: 'Rafraîchir'
						}
					},
					postingDescription: {
						backToSearchButtonText: 'Retour aux resultats',
						applyButtonText: 'Je postule',
						referButtonText: 'Recommander un(e) ami(e)',
					},
					sendCvPopUp: {
						sendCvDescription: 'Vous pouvez nous envoyer votre CV sans postuler à une offre précise',
						sendCvCountryListDescription: "Sélectionnez l'un des pays suivants:",
						popUpTitle: 'Déposez votre CV',
						applyButtonText: 'Appliquer',
						cancelButtonText: 'Annuler',
					},
					error: {
						noDataMessage: 'Actuellement aucune donnée est disponible!'
					}
				}
			},
			selectedPostId: null,
			visibleGridColumns: [],
			visibleCriteria: [],
			selectedCriteria: {
				keyWord: null,
				department: [],
				employmentType: [],
				jobFamily: [],
				location: [],
				country: [],
				ou: [],
			},
			filter: null,
			speculativeFilter: null,
			searchButtonVisible: true,
			referAFriendButtonVisible: true,
			applyButtonVisible: true,
			detailsBackButtonVisible: true,
			sendCvButtonVisible: true,
			jobAlertButtonVisible: false,
			jobAlertButtonBgColor: '00AE41',
			jobAlertButtonDataConfigurationId: 'D52506FF-628B-46A3-A072-147218B0B2A5',
			detailsLogoVisible: false,
			postingsGridPageSize: 10,
			useHashtagIdentifier: true,
			autoSearchOnCriteriaChange: false,
			showInternalJobs: false,
			//events
			onDetailsDisplay: null,
			onApplyButtonClick: null,
			onReferAFriendButtonClick: null,
			onDetailsBackButtonClick: null
		};

		// ---------------------------------------------------------------------------------------------
		// Returns an object which holds all the widget's settings.
		function getOptions() {
			// Overwrite default options with user custom options
			var options = mergeDeep(defaultOptions, config);

			options.jobAlertButtonBgColor = options.jobAlertButtonBgColor.replace('#', '');

			options.labels = mergeDeep(options.translation['en'], options.translation[options.language]);
			options.language = options.language.toLowerCase();

			if (options.visibleGridColumns == null || options.visibleGridColumns.length === 0)
				options.visibleGridColumns = ['sr_jobTitle', 'sr_employmentType', 'sr_jobFamily', 'sr_location', 'sr_hasReferal'];

			if (options.visibleCriteria == null || options.visibleCriteria.length === 0)
				options.visibleCriteria = ['sr_keyWord', 'sr_employmentType', 'sr_jobFamily', 'sr_location', 'sr_country'];

			options.hideCriteria = (config.visibleCriteria === null || config.visibleCriteria === []);

			options.allCountries = {
				'AF': 'Afghanistan',
				'AX': 'Åland Islands',
				'AL': 'Albania',
				'DZ': 'Algeria',
				'AS': 'American Samoa',
				'AD': 'AndorrA',
				'AO': 'Angola',
				'AI': 'Anguilla',
				'AQ': 'Antarctica',
				'AG': 'Antigua and Barbuda',
				'AR': 'Argentina',
				'AM': 'Armenia',
				'AW': 'Aruba',
				'AU': 'Australia',
				'AT': 'Austria',
				'AZ': 'Azerbaijan',
				'BS': 'Bahamas',
				'BH': 'Bahrain',
				'BD': 'Bangladesh',
				'BB': 'Barbados',
				'BY': 'Belarus',
				'BE': 'Belgium',
				'BZ': 'Belize',
				'BJ': 'Benin',
				'BM': 'Bermuda',
				'BT': 'Bhutan',
				'BO': 'Bolivia',
				'BA': 'Bosnia and Herzegovina',
				'BW': 'Botswana',
				'BV': 'Bouvet Island',
				'BR': 'Brazil',
				'IO': 'British Indian Ocean Territory',
				'BN': 'Brunei Darussalam',
				'BG': 'Bulgaria',
				'BF': 'Burkina Faso',
				'BI': 'Burundi',
				'KH': 'Cambodia',
				'CM': 'Cameroon',
				'CA': 'Canada',
				'CV': 'Cape Verde',
				'KY': 'Cayman Islands',
				'CF': 'Central African Republic',
				'TD': 'Chad',
				'CL': 'Chile',
				'CN': 'China',
				'CX': 'Christmas Island',
				'CC': 'Cocos (Keeling) Islands',
				'CO': 'Colombia',
				'KM': 'Comoros',
				'CG': 'Congo',
				'CD': 'Congo, The Democratic Republic of the',
				'CK': 'Cook Islands',
				'CR': 'Costa Rica',
				'CI': 'Cote D\'Ivoire',
				'HR': 'Croatia',
				'CU': 'Cuba',
				'CY': 'Cyprus',
				'CZ': 'Czech Republic',
				'DK': 'Denmark',
				'DJ': 'Djibouti',
				'DM': 'Dominica',
				'DO': 'Dominican Republic',
				'EC': 'Ecuador',
				'EG': 'Egypt',
				'SV': 'El Salvador',
				'GQ': 'Equatorial Guinea',
				'ER': 'Eritrea',
				'EE': 'Estonia',
				'ET': 'Ethiopia',
				'FK': 'Falkland Islands (Malvinas)',
				'FO': 'Faroe Islands',
				'FJ': 'Fiji',
				'FI': 'Finland',
				'FR': 'France',
				'GF': 'French Guiana',
				'PF': 'French Polynesia',
				'TF': 'French Southern Territories',
				'GA': 'Gabon',
				'GM': 'Gambia',
				'GE': 'Georgia',
				'DE': 'Germany',
				'GH': 'Ghana',
				'GI': 'Gibraltar',
				'GR': 'Greece',
				'GL': 'Greenland',
				'GD': 'Grenada',
				'GP': 'Guadeloupe',
				'GU': 'Guam',
				'GT': 'Guatemala',
				'GG': 'Guernsey',
				'GN': 'Guinea',
				'GW': 'Guinea-Bissau',
				'GY': 'Guyana',
				'HT': 'Haiti',
				'HM': 'Heard Island and Mcdonald Islands',
				'VA': 'Holy See (Vatican City State)',
				'HN': 'Honduras',
				'HK': 'Hong Kong',
				'HU': 'Hungary',
				'IS': 'Iceland',
				'IN': 'India',
				'ID': 'Indonesia',
				'IR': 'Iran, Islamic Republic Of',
				'IQ': 'Iraq',
				'IE': 'Ireland',
				'IM': 'Isle of Man',
				'IL': 'Israel',
				'IT': 'Italy',
				'JM': 'Jamaica',
				'JP': 'Japan',
				'JE': 'Jersey',
				'JO': 'Jordan',
				'KZ': 'Kazakhstan',
				'KE': 'Kenya',
				'KI': 'Kiribati',
				'KP': 'Korea, Democratic People\'S Republic of',
				'KR': 'Korea, Republic of',
				'KW': 'Kuwait',
				'KG': 'Kyrgyzstan',
				'LA': 'Lao People\'S Democratic Republic',
				'LV': 'Latvia',
				'LB': 'Lebanon',
				'LS': 'Lesotho',
				'LR': 'Liberia',
				'LY': 'Libyan Arab Jamahiriya',
				'LI': 'Liechtenstein',
				'LT': 'Lithuania',
				'LU': 'Luxembourg',
				'MO': 'Macao',
				'MK': 'Macedonia, The Former Yugoslav Republic of',
				'MG': 'Madagascar',
				'MW': 'Malawi',
				'MY': 'Malaysia',
				'MV': 'Maldives',
				'ML': 'Mali',
				'MT': 'Malta',
				'MH': 'Marshall Islands',
				'MQ': 'Martinique',
				'MR': 'Mauritania',
				'MU': 'Mauritius',
				'YT': 'Mayotte',
				'MX': 'Mexico',
				'FM': 'Micronesia, Federated States of',
				'MD': 'Moldova, Republic of',
				'MC': 'Monaco',
				'MN': 'Mongolia',
				'MS': 'Montserrat',
				'MA': 'Morocco',
				'MZ': 'Mozambique',
				'MM': 'Myanmar',
				'NA': 'Namibia',
				'NR': 'Nauru',
				'NP': 'Nepal',
				'NL': 'Netherlands',
				'AN': 'Netherlands Antilles',
				'NC': 'New Caledonia',
				'NZ': 'New Zealand',
				'NI': 'Nicaragua',
				'NE': 'Niger',
				'NG': 'Nigeria',
				'NU': 'Niue',
				'NF': 'Norfolk Island',
				'MP': 'Northern Mariana Islands',
				'NO': 'Norway',
				'OM': 'Oman',
				'PK': 'Pakistan',
				'PW': 'Palau',
				'PS': 'Palestinian Territory, Occupied',
				'PA': 'Panama',
				'PG': 'Papua New Guinea',
				'PY': 'Paraguay',
				'PE': 'Peru',
				'PH': 'Philippines',
				'PN': 'Pitcairn',
				'PL': 'Poland',
				'PT': 'Portugal',
				'PR': 'Puerto Rico',
				'QA': 'Qatar',
				'RE': 'Reunion',
				'RO': 'Romania',
				'RU': 'Russian Federation',
				'RW': 'RWANDA',
				'SH': 'Saint Helena',
				'KN': 'Saint Kitts and Nevis',
				'LC': 'Saint Lucia',
				'PM': 'Saint Pierre and Miquelon',
				'VC': 'Saint Vincent and the Grenadines',
				'WS': 'Samoa',
				'SM': 'San Marino',
				'ST': 'Sao Tome and Principe',
				'SA': 'Saudi Arabia',
				'SN': 'Senegal',
				'CS': 'Serbia and Montenegro',
				'RS': 'Serbia',
				'SC': 'Seychelles',
				'SL': 'Sierra Leone',
				'SG': 'Singapore',
				'SK': 'Slovakia',
				'SI': 'Slovenia',
				'SB': 'Solomon Islands',
				'SO': 'Somalia',
				'ZA': 'South Africa',
				'GS': 'South Georgia and the South Sandwich Islands',
				'ES': 'Spain',
				'LK': 'Sri Lanka',
				'SD': 'Sudan',
				'SR': 'Suriname',
				'SJ': 'Svalbard and Jan Mayen',
				'SZ': 'Swaziland',
				'SE': 'Sweden',
				'CH': 'Switzerland',
				'SY': 'Syrian Arab Republic',
				'TW': 'Taiwan, Province of China',
				'TJ': 'Tajikistan',
				'TZ': 'Tanzania, United Republic of',
				'TH': 'Thailand',
				'TL': 'Timor-Leste',
				'TG': 'Togo',
				'TK': 'Tokelau',
				'TO': 'Tonga',
				'TT': 'Trinidad and Tobago',
				'TN': 'Tunisia',
				'TR': 'Turkey',
				'TM': 'Turkmenistan',
				'TC': 'Turks and Caicos Islands',
				'TV': 'Tuvalu',
				'UG': 'Uganda',
				'UA': 'Ukraine',
				'AE': 'United Arab Emirates',
				'GB': 'United Kingdom',
				'US': 'United States',
				'UM': 'United States Minor Outlying Islands',
				'UY': 'Uruguay',
				'UZ': 'Uzbekistan',
				'VU': 'Vanuatu',
				'VE': 'Venezuela',
				'VN': 'Viet Nam',
				'VG': 'Virgin Islands, British',
				'VI': 'Virgin Islands, U.S.',
				'WF': 'Wallis and Futuna',
				'EH': 'Western Sahara',
				'YE': 'Yemen',
				'ZM': 'Zambia',
				'ZW': 'Zimbabwe'
			};

			//var searchTemplate = $('#search-template').html();
			//$('#search-template').html().replace(/(\r\n|\n|\r)/gm,"")
			options.searchTemplate = '<form id="sr-widget-form">        <div id="sr-widget-search-filters-container" class="sr-widget-search-filters-container">            <h3 class="sr-widget-section-header">#:labels.criteria.headerText#</h3>            <div class="sr-widget-search-filter-criteria">                <label for="sr-widget-keyword" class="sr-widget-search-criteria-label">#:labels.criteria.keywordLabel#</label>                <input type="search" id="sr-widget-keyword" placeholder="#:labels.criteria.keywordPlaceholder#" />            </div>            <div class="sr-widget-search-filter-criteria">                <label for="sr-widget-department" class="sr-widget-search-criteria-label">#:labels.criteria.departmentLabel#</label>                <select id="sr-widget-department" data-placeholder="#:labels.criteria.departmentPlaceholder#" multiple="multiple"></select>            </div>            <div class="sr-widget-search-filter-criteria">                <label for="sr-widget-job-family" class="sr-widget-search-criteria-label">#:labels.criteria.jobFamilyLabel#</label>                <select id="sr-widget-job-family" data-placeholder="#:labels.criteria.jobFamilyPlaceholder#" multiple="multiple"></select>            </div>            <div class="sr-widget-search-filter-criteria">                <label for="sr-widget-employment-type" class="sr-widget-search-criteria-label">#:labels.criteria.employmentTypeLabel#</label>                <select id="sr-widget-employment-type" data-placeholder="#:labels.criteria.employmentTypePlaceholder#" multiple="multiple"></select>            </div>            <div class="sr-widget-search-filter-criteria">                <label for="sr-widget-location" class="sr-widget-search-criteria-label">#:labels.criteria.locationLabel#</label>                <select id="sr-widget-location" data-placeholder="#:labels.criteria.locationPlaceholder#" multiple="multiple"></select>            </div>            <div class="sr-widget-search-filter-criteria">                <label for="sr-widget-country" class="sr-widget-search-criteria-label">#:labels.criteria.countryLabel#</label>                <select type="text" id="sr-widget-country" data-placeholder="#:labels.criteria.countryPlaceholder#" multiple="multiple"></select>    </div>  <div class="sr-widget-search-filter-criteria">                <label for="sr-widget-ou" class="sr-widget-search-criteria-label">#:labels.criteria.countryLabel#</label>                <select type="text" id="sr-widget-ou" data-placeholder="#:labels.criteria.ouPlaceholder#" multiple="multiple"></select>        </div>          <div class="sr-widget-search-filter-commands">                # if(searchButtonVisible) {#                <button id="sr-widget-search" class="sr-widget-search-button" type="submit">#:labels.criteria.searchButtonText#</button>                # } else { #                <button id="sr-widget-search" class="sr-widget-search-button" type="submit" style="display:none">#:labels.criteria.searchButtonText#</button>                # } #                <button id="sr-widget-reset-filters" class="sr-widget-reset-button" type="reset">#:labels.criteria.resetFiltersButtonText#</button>                # if(sendCvButtonVisible) {#                <button id="sr-widget-send-cv" class="sr-widget-send-cv-button">#:labels.criteria.sendCvButtonText#</button>                # } else { #                <button id="sr-widget-send-cv" class="sr-widget-send-cv-button" style="display:none">#:labels.criteria.sendCvButtonText#</button>                # } #				# if (jobAlertButtonVisible) {#				<button id="sr-widget-job-notify" class="sr-widget-job-notify-button">#:labels.criteria.createJobAlertButtonText#</button>				<div id="sr-widget-alert-button-container">					<div id="sr-plugins" data-configuration-id="#:jobAlertButtonDataConfigurationId#" data-bg="#:jobAlertButtonBgColor#" data-lang="#:language#-#:language#"></div>					<div id="sr-alert-button" data-type="SIMPLE"></div>				</div>				# } #            </div>            <div class="clear"></div>        </div>        <div class="clear"></div>        <div class="sr-widget-grid-results-container">            <h3 class="sr-widget-section-header">#:labels.postingsGrid.headerText#</h3>            <div id="sr-widget-job-grid"></div>        </div>        <div class="clear"></div>        <div id="sr-widget-job-description-container">        </div>        <div class="clear"></div>        <div id="sr-widget-window"></div>    </form>';

			//var detailsTemplate = $("#details-template").html();
			//$('#details-template').html().replace(/(\r\n|\n|\r)/gm,"")
			options.detailsTemplate = '        <div class="sr-widget-header">            # if(options.detailsBackButtonVisible) {#            <div class="sr-widget-navigation-section">                <button id="sr-widget-job-description-back-button" class="sr-widget-job-description-back-button">#:options.labels.postingDescription.backToSearchButtonText#</button>            </div>            # } #            # if(options.detailsLogoVisible) {#            <div class="sr-widget-logo-section">                <div id="sr-widget-logo-image" class="sr-widget-logo-image"></div>            </div>            # } #            <div class="sr-widget-details-title-container">                <span class="sr-widget-details-main-title">                    #: name # # if (typeof(department) !== "undefined") { #  (#:department.label#) # } #                </span>                <span class="sr-widget-details-sub-title">                    #: location.city #, #:country # #: typeof(typeOfEmployment) !== "undefined" ?  (" - "  + typeOfEmployment.label) : "" # #: typeof(refNumber) !== "undefined" ?  (" - "  + refNumber) : "" #                </span>                <ul class="sr-widget-social-list">                    <li class="sr-widget-social-item">                        <a class="sr-widget-icon-linkedin" href="#linkedInRedirectUrl#" target="_blank">                        </a>                    </li>                    <li class="sr-widget-social-item">                        <a class="sr-widget-icon-facebook" href="#facebookRedirectUrl#" target="_blank">                        </a>                    </li>                    <li class="sr-widget-social-item">                        <a class="sr-widget-icon-twitter" href="#twitterRedirectUrl#" target="_blank">                        </a>                    </li>                    <li class="sr-widget-social-item">                        <a class="sr-widget-icon-mail" href="#mailRedirectUrl#">                        </a>                    </li>                </ul>                <div class="sr-widget-detail-action-list">                    # if(options.applyButtonVisible) {#                    <a class="sr-widget-apply-button" href="#:applyButtonUrl#" target="_blank">#:options.labels.postingDescription.applyButtonText#</a>                    # } #                    # if(options.referAFriendButtonVisible) {#                    <a class="sr-widget-refer-button" href="#:referAFriendButtonUrl#" target="_blank">#:options.labels.postingDescription.referButtonText#</a>                    # } #                </div>            </div>        </div>        <div class="clear"></div>        <div class="sr-widget-section-container">            # for (section in jobAd.sections) {            if (jobAd.sections[section].text)            { #            <h3 class="sr-widget-section-title">#:jobAd.sections[section].title#</h3>            <div class="sr-widget-section-details">                #=jobAd.sections[section].text#            </div>            # } else if (jobAd.sections[section].urls) { #            <h3 class="sr-widget-section-title">#:jobAd.sections[section].title#</h3>            #  for (var x = 0; x < jobAd.sections[section].urls.length; x++) { #            <ul class="sr-widget-section-video-list">                <li class="sr-widget-video-list">                    <div style="background-image: url(https://img.youtube.com/vi/#:srWidget.extractYouTubeId(jobAd.sections[section].urls[x])#/default.jpg)" class="sr-widget-video-item" data-video="https://www.youtube.com/embed/#:srWidget.extractYouTubeId(jobAd.sections[section].urls[x])#">                        <span class="sr-widget-play-video">                        </span>                    </div>                </li>            </ul>            # } #            # } } #        </div>        <div class="clear"></div>        <div class="sr-widget-footer">            <div class="sr-widget-detail-action-list">                # if(options.applyButtonVisible) {#                <a class="sr-widget-apply-button" href="#:applyButtonUrl#" target="_blank">#:options.labels.postingDescription.applyButtonText#</a>                # } #                # if(options.referAFriendButtonVisible) {#                <a class="sr-widget-refer-button" href="#:referAFriendButtonUrl#" target="_blank">#:options.labels.postingDescription.referButtonText#</a>                # } #            </div>            <ul class="sr-widget-social-list">                <li class="sr-widget-social-item">                    <a class="sr-widget-icon-linkedin" href="#linkedInRedirectUrl#" target="_blank">                    </a>                </li>                <li class="sr-widget-social-item">                    <a class="sr-widget-icon-facebook" href="#facebookRedirectUrl#" target="_blank">                    </a>                </li>                <li class="sr-widget-social-item">                    <a class="sr-widget-icon-twitter" href="#twitterRedirectUrl#" target="_blank">                    </a>                </li>                <li class="sr-widget-social-item">                    <a class="sr-widget-icon-mail" href="#mailRedirectUrl#">                    </a>                </li>            </ul>        </div>        <div class="clear"></div>    ';

			//var sendCvTemplate = $('#send-cv-template').html();
			//$('#send-cv-template').html().replace(/(\r\n|\n|\r)/gm,"")
			options.sendCvTemplate = '        <div class="sr-widget-send-cv-container">            <h3 class="sr-widget-send-cv-title">#:options.labels.sendCvPopUp.sendCvDescription#</h3>            <div class="sr-widget-send-cv-contry-selection-container">                #:options.labels.sendCvPopUp.sendCvCountryListDescription#                <select id="sr-widget-send-cv-country" style="width:250px;">                    # for (var i = 0; i < countries.length; i++) { #                    <option value="#:countries[i].jobid#">#:countries[i].name#</option>                    # } #                </select>            </div>            <div class="sr-widget-send-cv-action-list">                <a target="_blank" href="" id="sr-widget-send-cv-apply-button" class="sr-widget-send-cv-apply-button">#:options.labels.sendCvPopUp.applyButtonText#</a>                <button id="sr-widget-send-cv-cancel-button" class=" sr-widget-send-cv-cancel-button">#:options.labels.sendCvPopUp.cancelButtonText#</button>            </div>        </div>    ';

			//var responsiveGridItemTemplate = $('#responsive-grid-item-template').html();
			//$('#responsive-grid-item-template').html().replace(/(\r\n|\n|\r)/gm,"")
			options.responsiveGridItemTemplate = '        <span class="sr-widget-mobile-job-grid-title">#:sr_jobTitle# #: sr_department ? "(" + sr_department + ")" : "" #</span>        <span class="sr-widget-mobile-job-grid-sub-title">#: sr_location #, #: sr_country #</span>';

			return options;
		}

		var options = getOptions();

		// ---------------------------------------------------------------------------------------------
		// Configure the widget, download the grid data and add the grid to the DOM.
		function configureWidget($, kendo) {
			// ---------------------------------------------------------------------------------------------
			// Inject the widget into the DOM.
			function placeWidgetInLocation(container, widget) {
				if (!container || !container.length)
					$('script')
						.filter(function (idx) {
							return !!~this.innerHTML.indexOf('srWidget(');
						}).after(widget);
				else
					$(container).append(widget);

				$('#sr-widget-loading').remove();
			}

			// Show a loading indicator
			var widgetLocation = options.widgetContainerSelector != null ? $(options.widgetContainerSelector) : $('[data-sr-widget]');

			var tempElement = $('<div id="sr-widget-container" />');
			tempElement.html(kendo.template(options.searchTemplate)(options));

			var keywordTextBox = $('#sr-widget-keyword', tempElement);
			var departmentMultiSelect = $('#sr-widget-department', tempElement);
			var jobFamilyMultiSelect = $('#sr-widget-job-family', tempElement);
			var employmentTypeMultiSelect = $('#sr-widget-employment-type', tempElement);
			var locationMultiSelect = $('#sr-widget-location', tempElement);
			var countryMultiSelect = $('#sr-widget-country', tempElement);
			var ouMultiSelect = $('#sr-widget-ou', tempElement);

			// ---------------------------------------------------------------------------------------------
			// Configure the grid that will display the data.
			function configureGrid(speculativeJobPositions) {
				// Configures and returns an array holding the grid's columns.
				function configureGridColumns() {
					var columns = [];

					//columns
					var responsiveColumnTemplate = [options.responsiveGridItemTemplate];
					if ($.inArray('sr_jobTitle', options.visibleGridColumns) > -1) {
						columns.push({
							field: 'sr_jobTitle'
							, title: options.labels.postingsGrid.jobTitleColumnTitle
							, headerAttributes: {
								"class": 'sr-non-responsive-grid-header-cell'
							}, attributes: {
								"class": 'sr-non-responsive-grid-cell'
							},
							template: "<a href='\\#sr-post-id=#:id#&is-redirect=true' onclick='return false;'>#: sr_jobTitle ? sr_jobTitle : '' #</a>"
						});
					}

					if ($.inArray('sr_jobFamily', options.visibleGridColumns) > -1) {
						columns.push({
							field: 'sr_jobFamily'
							, title: options.labels.postingsGrid.departmentColumnTitle
							, headerAttributes: {
								"class": 'sr-non-responsive-grid-header-cell'
							}, attributes: {
								"class": 'sr-non-responsive-grid-cell'
							},
							template: "<a href='\\#sr-post-id=#:id#&is-redirect=true' onclick='return false;'>#: sr_department ? sr_department : '' #</a>"
						});
					}

					if ($.inArray('sr_employmentType', options.visibleGridColumns) > -1) {
						columns.push({
							field: 'sr_employmentType'
							, title: options.labels.postingsGrid.employemntTypeColumnTitle
							, headerAttributes: {
								"class": 'sr-non-responsive-grid-header-cell'
							}, attributes: {
								"class": 'sr-non-responsive-grid-cell'
							},
							template: "<a href='\\#sr-post-id=#:id#&is-redirect=true' onclick='return false;'>#: sr_employmentType ? sr_employmentType : '' #</a>"
						});
					}

					//if ($.inArray("sr_jobFamily", options.visibleGridColumns) > -1)
					//{
					//    columns.push({
					//        field: "sr_jobFamily"
					//        , title: options.labels.postingsGrid.jobFamilyColumnTitle
					//        , headerAttributes: {
					//            "class": "sr-non-responsive-grid-header-cell"
					//        }, attributes: {
					//            "class": "sr-non-responsive-grid-cell"
					//        },
					//        template: "<a href='\\#sr-post-id=#:id#&is-redirect=true' onclick='return false;'>#: sr_jobFamily ? sr_jobFamily : '' #</a>"
					//    });
					//}

					if ($.inArray('sr_location', options.visibleGridColumns) > -1) {
						columns.push({
							field: 'sr_location'
							, title: options.labels.postingsGrid.locationColumnTitle
							, headerAttributes: {
								"class": 'sr-non-responsive-grid-header-cell'
							}, attributes: {
								"class": 'sr-non-responsive-grid-cell'
							},
							template: "<a href='\\#sr-post-id=#:id#&is-redirect=true' onclick='return false;'>#: sr_location #, #: sr_country #</a>"
						});
					}

					if ($.inArray('sr_hasReferal', options.visibleGridColumns) > -1) {
						columns.push({
							field: 'sr_hasReferal'
							, title: options.labels.postingsGrid.hasBonusReferalColumnTitle
							, headerAttributes: {
								"class": 'sr-non-responsive-grid-header-cell'
							}, attributes: {
								"class": 'sr-non-responsive-grid-cell'
							},
							template: "<a href='\\#sr-post-id=#:id#&is-redirect=true' onclick='return false;'>#: sr_hasReferal ? '" + options.labels.postingsGrid.hasBonusReferalYesLabel + "' : '' #</a>"
						});
					}

					columns.push({
						field: 'sr_jobTitle'
						, title: options.labels.postingsGrid.jobSingleColumnMobileTitle
						, template: responsiveColumnTemplate.join('<br />')
						, headerAttributes: {
							"class": 'sr-responsive-grid-header-cell'
						}, attributes: {
							"class": 'sr-responsive-grid-cell'
						}
					});

					return columns;
				}

				var $widgetJobGrid = $('#sr-widget-job-grid', tempElement);
				var kendoJobGrid = $widgetJobGrid.kendoGrid({
					columns: configureGridColumns(),
					sortable: true,
					pageable: {
						enabled: true,
						messages: options.labels.postingsGrid.gridPagerMessage
					},
					scrollable: false,
					autoBind: false
				}).getKendoGrid();

				$widgetJobGrid.off('click');
				$widgetJobGrid.on('click', '> table > tbody > tr[role=row]', function (e) {
					var posting = kendoJobGrid.dataItem(this);

					var isCanceled = false;
					var eventArgs = {
						id: posting.id,
						posting: posting,
						preventDefault: function () {
							isCanceled = true;
						}
					};

					if (options.onDetailsDisplay !== null && options.onDetailsDisplay(eventArgs))
						isCanceled = true;

					if (!isCanceled)
						showDetails(posting.id, true, true);

					e.preventDefault();
					return false;
				});

				var $widgetJobDescriptionContainer = $('#sr-widget-job-description-container', tempElement);

				$widgetJobDescriptionContainer.on('click', '#sr-widget-job-description-back-button, #widget-job-description-path_search', function (e) {
					var posting = $widgetJobDescriptionContainer.data('posting');

					var isCanceled = false;
					var eventArgs = {
						id: posting.id,
						posting: posting,
						preventDefault: function () {
							isCanceled = true;
						}
					};

					if (options.onDetailsBackButtonClick !== null && options.onDetailsBackButtonClick(eventArgs))
						isCanceled = true;

					if (!isCanceled) {
						$widgetJobDescriptionContainer.stop().animate({
							top: '1000px'
						}, 200, 'linear', function () {
							$widgetJobDescriptionContainer.hide();
							$widgetJobDescriptionContainer.html(null);
							window.location.hash = '';
						});

						if (!options.hideCriteria)
							$('.sr-widget-search-filters-container', tempElement).show();

						$('.sr-widget-grid-results-container', tempElement).show();
					}

					e.preventDefault();
					return false;
				});

				var kendoWindow = $('#sr-widget-window', tempElement).kendoWindow({
					modal: true,
					actions: [
						'Close'
					],
					close: function () {
						kendoWindow.content('');
					}
				}).getKendoWindow();

				$('#sr-widget-job-description-container', tempElement).on('click', '.sr-widget-video-item', function () {
					kendoWindow.title('Video');
					kendoWindow.content('<iframe width="560" height="315" src="' + $(this).data('video') + '?autoplay=1" frameborder="0" allowfullscreen=""></iframe>');
					kendoWindow.open().center();
				});

				speculativeJobPositions = speculativeJobPositions || [];
				if (speculativeJobPositions.length == 0) {
					$('#sr-widget-send-cv', tempElement).remove();
				}
				else {
					$('#sr-widget-send-cv', tempElement).on('click', function (e) {

						var sendCvWindowModel = {
							countries: $.map(speculativeJobPositions, function (item) {
								return {
									name: item.sr_country, jobid: item.id
								};
							})
						};

						sendCvWindowModel.countries = $(sendCvWindowModel.countries).sort(function (a, b) {
							return (b.name < a.name) ? 1 : -1;
						});

						sendCvWindowModel.options = options;

						kendoWindow.title(options.labels.sendCvPopUp.popUpTitle);
						kendoWindow.content(kendo.template(options.sendCvTemplate)(sendCvWindowModel));
						kendoWindow.center().open();
						$('#sr-widget-send-cv-apply-button').hide();
						$('#sr-widget-send-cv-country').kendoComboBox({
							filter: 'contains',
							placeholder: 'Select...',
							change: function () {
								if (this.value() == -1 || this.value() == '' || this.value() == null) {
									$('#sr-widget-send-cv-apply-button').hide();
								}
								else {
									$('#sr-widget-send-cv-apply-button').show();
									$('#sr-widget-send-cv-apply-button').attr('href', options.speculativeUrl.replace('#:id#', this.value()));
								}

							},
						});
						$('#sr-widget-send-cv-country').getKendoComboBox().value('');
						$('#sr-widget-send-cv-cancel-button').on('click', function () {
							kendoWindow.close();
						});

						e.preventDefault();
						return false;
					});
				}

				$(window).on('hashchange', function () {
					var selectedPostId = getSelectedHashId();
					if (selectedPostId && !$('#sr-widget-job-description-container').is(':animated')) {
						showDetails(selectedPostId, true, false);
					}
				});

				return kendoJobGrid;
			}

			// ---------------------------------------------------------------------------------------------
			// Display the grid.
			function displayGrid() {
				var selectedPostId = getSelectedPostId();

				if (selectedPostId) {
					showDetails(selectedPostId, false, false).then(function (canceled) {
						if (!canceled)
							placeWidgetInLocation(widgetLocation, tempElement);
					});
				}
				else
					placeWidgetInLocation(widgetLocation, tempElement);

				// Configure the "Create Job Alert" button. This can only be done once the UI has been loaded.
				if (options.jobAlertButtonVisible) {
					(function (d, s, id) {
						var js, fjs = d.getElementsByTagName(s)[0];
						if (d.getElementById(id)) return;
						js = d.createElement(s); js.id = id;
						js.src = 'https://subscriptions.smartrecruiters.com/widget/v1/sr-job-alerts.js';
						fjs.parentNode.insertBefore(js, fjs);


						var resizeTimeout;
						var isConfirmed = false;

						var notifyHandler = document.getElementById('sr-widget-job-notify');
						if (!notifyHandler) return;

						notifyHandler.addEventListener('click', sendMessage);
						parent.postMessage({ action: 'setButtonHeight', height: notifyHandler.offsetHeight }, '*');


						function resizeThrottler() {
							// ignore resize events as long as an actualResizeHandler execution is in the queue
							if (!resizeTimeout) {
								resizeTimeout = setTimeout(function () {
									resizeTimeout = null;
									actualResizeHandler();
									// The actualResizeHandler will execute at a rate of 15fps
								}, 66);
							}
						}

						function actualResizeHandler() {
							parent.postMessage({ action: 'setButtonHeight', height: notifyHandler.offsetHeight }, '*');
						}

						window.addEventListener('resize', resizeThrottler, false);

						// Ask for Job Alert Widget once user clicks the button
						function sendMessage() {
							// Send message to show Job Alert Widget
							parent.postMessage({ action: 'jobAlertWidget-Show' }, '*');

							// Wait for confirmation from parent
							window.addEventListener('message', receiveMessage, false);
							setTimeout(function () {
								window.removeEventListener('message', receiveMessage);
								if (!isConfirmed) openManually();
							}, 2000);

						}

						// Receive confirmation that parent made it
						function receiveMessage(event) {
							if (event.data === 'jobAlertWidget-Shown') {
								isConfirmed = true;
							}
						}

						// Takes care itself if parent didn't make it
						function openManually() {
							// build url
							// open new window
							console.log('open widget in new window');
						}

					})(document, 'script', 'sr-jsplugins');
				}
			}

			// ---------------------------------------------------------------------------------------------
			function getSelectedPostId() {
				return getSelectedHashId() || options.selectedPostId;
			}

			// ---------------------------------------------------------------------------------------------
			function getSelectedHashId() {
				if (window.location.hash && options.useHashtagIdentifier) {
					var search = window.location.hash.replace('#', '');
					var hastagSelectedPosts = srWidget.parseQuery(search);
					return hastagSelectedPosts['sr-post-id'];
				}

				return null;
			}

			// ---------------------------------------------------------------------------------------------
			// Configure the filters that can be applied to the grid.
			function configureFilters(jobPositions, kendoGrid) {
				var locations = {},
					departments = {},
					jobFamilies = {},
					employmentTypes = {},
					countries = {},
					ous = {
					};

				// Hide the virtual keyboard on iOs/Android
				var hideKeyboard = function () {
					var activeElement = $(document.activeElement);

					activeElement.attr('readonly', 'readonly').attr('disabled', 'true');

					setTimeout(function () {
						activeElement.blur().removeAttr('readonly').removeAttr('disabled');
					});
				};

				// Search in the list of jobs
				var searchJobs = function () {
					hideKeyboard();
					var gridFilters = [];

					var keyWord = keywordTextBox.data('kendoMaskedTextBox').value();
					if (keyWord) {
						var keyWords = keyWord.split(';');

						var keyWordsContainParis = false;
						var keyWordsContainMontreuil = false;

						$.each(keyWords, function (k, v) {
							if (v.toUpperCase() === 'PARIS')
								keyWordsContainParis = true;

							if (v.toUpperCase() === 'MONTREUIL')
								keyWordsContainMontreuil = true;
						});

						if (keyWordsContainParis && !keyWordsContainMontreuil)
							keyWords.push('Montreuil');

						if (!keyWordsContainParis && keyWordsContainMontreuil)
							keyWords.push('Paris');

						var keyWordFilters = [];
						for (var j = 0; j < keyWords.length; j++) {
							keyWordFilters.push({
								"field": 'sr_jobTitle',
								"operator": 'contains',
								"value": keyWords[j]
							});
							keyWordFilters.push({
								"field": 'sr_location',
								"operator": 'contains',
								"value": keyWords[j]
							});
							keyWordFilters.push({
								"field": 'sr_country',
								"operator": 'contains',
								"value": keyWords[j]
							});
						}

						gridFilters.push({
							logic: 'or',
							filters: keyWordFilters
						});
					}

					var department = departmentMultiSelect.data('kendoMultiSelect').value();
					if (department.length)
						gridFilters.push({
							logic: 'or',
							filters: $.map(department,
								function (v) {
									return {
										field: 'sr_department',
										operator: 'eq',
										value: v
									};
								})
						});

					var jobFamily = jobFamilyMultiSelect.data('kendoMultiSelect').value();
					if (jobFamily.length)
						gridFilters.push({
							logic: 'or',
							filters: $.map(jobFamily,
								function (v) {
									return {
										field: 'sr_jobFamily',
										operator: 'eq',
										value: v
									}
								})
						});

					var employmentType = employmentTypeMultiSelect.data('kendoMultiSelect').value();
					if (employmentType.length) {
						gridFilters.push({
							logic: 'or',
							filters: $.map(employmentType,
								function (v) {
									return {
										field: 'sr_employmentType',
										operator: 'eq',
										value: v
									}
								})
						});
					}

					var location = locationMultiSelect.data('kendoMultiSelect').value();
					if (location.length) {
						var filters = $.map(location,
							function (v) {
								return {
									field: 'sr_location',
									operator: 'eq',
									value: v
								};
							});

						var locationValuesContainParis = false;
						var locationValuesContainMontreuil = false;

						$.each(filters, function (k, f) {
							if (f.value.toUpperCase() === 'PARIS')
								locationValuesContainParis = true;

							if (f.value.toUpperCase() === 'MONTREUIL')
								locationValuesContainMontreuil = true;
						});

						if (locationValuesContainParis && !locationValuesContainMontreuil)
							filters.push({
								field: 'sr_location', operator: 'eq', value: 'Montreuil'
							});

						if (!locationValuesContainParis && locationValuesContainMontreuil)
							filters.push({
								field: 'sr_location', operator: 'eq', value: 'Paris'
							});

						gridFilters.push({
							logic: 'or',
							filters: filters
						});
					}

					var country = countryMultiSelect.data('kendoMultiSelect').value();
					if (country.length)
						gridFilters.push({
							logic: 'or',
							filters: $.map(country,
								function (v) {
									return {
										field: 'sr_country',
										operator: 'eq',
										value: v
									}
								})
						});

					var ou = ouMultiSelect.data('kendoMultiSelect').value();
					if (ou.length)
						gridFilters.push({
							logic: 'or',
							filters: $.map(ou,
								function (v) {
									return {
										field: 'sr_ou',
										operator: 'eq',
										value: v
									}
								})
						});

					kendoGrid.dataSource.filter(gridFilters);
				};

				var autoSearch = function (e) {
					if (options.autoSearchOnCriteriaChange)
						searchJobs();
				};

				for (var i = 0; i < jobPositions.length; i++) {
					var job = jobPositions[i];

					//fill departments list
					if (job.sr_department)
						departments[job.sr_department] = true;

					//fill job family list
					if (job.sr_jobFamily)
						jobFamilies[job.sr_jobFamily] = true;

					//fill employment types
					if (job.sr_employmentType)
						employmentTypes[job.sr_employmentType] = true;

					//fill location dropdownlist
					if (job.sr_location)
						locations[job.sr_location] = true;

					//fill countries dropdownlist
					if (job.sr_country)
						countries[job.sr_country] = true;

					//fill ous dropdownlist
					if (job.sr_ou)
						ous[job.sr_ou] = true;
				}

				var getOptionList = function (data) {
					// Sort the data alphabetically
					data = $(Object.keys(data || {})).sort(function (a, b) {
						var aName = a.toLowerCase();
						var bName = b.toLowerCase();
						return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
					});

					var optionList = $.map(data, function (x) {
						return '<option value="' + x + '">' + x + '</option>';
					});

					return optionList.toString('');
				};

				// Configure keywords filter
				if (!($.inArray('sr_keyWord', options.visibleCriteria) > -1))
					keywordTextBox.parent().hide();

				keywordTextBox.kendoMaskedTextBox({
					change: autoSearch
				});

				if (options.selectedCriteria && options.selectedCriteria.keyWord)
					keywordTextBox.data('kendoMaskedTextBox').value(options.selectedCriteria.keyWord);

				// Configure department filter
				departmentMultiSelect.html(getOptionList(departments));

				if (!($.inArray('sr_jobFamily', options.visibleCriteria) > -1))
					departmentMultiSelect.parent().hide();

				departmentMultiSelect.kendoMultiSelect({
					autoClose: false,
					close: autoSearch,
					filter: 'contains'
				});

				if (options.selectedCriteria && options.selectedCriteria.department)
					departmentMultiSelect.data('kendoMultiSelect').value(options.selectedCriteria.department);

				// Configure kendo job family multiselect
				jobFamilyMultiSelect.html(getOptionList(jobFamilies));

				jobFamilyMultiSelect.parent().hide();

				jobFamilyMultiSelect.kendoMultiSelect({
					autoClose: false,
					close: autoSearch,
					filter: 'contains'
				});

				if (options.selectedCriteria && options.selectedCriteria.jobFamily)
					jobFamilyMultiSelect.data('kendoMultiSelect').value(options.selectedCriteria.jobFamily);

				//init kendo employment type multiselect
				employmentTypeMultiSelect.html(getOptionList(employmentTypes));

				if (!($.inArray('sr_employmentType', options.visibleCriteria) > -1))
					employmentTypeMultiSelect.parent().hide();

				employmentTypeMultiSelect.kendoMultiSelect({
					autoClose: false,
					close: autoSearch,
					filter: 'contains'
				});

				if (options.selectedCriteria && options.selectedCriteria.employmentType)
					employmentTypeMultiSelect.data('kendoMultiSelect').value(options.selectedCriteria.employmentType);

				//init kendo location multiselect
				locationMultiSelect.html(getOptionList(locations));

				if (!($.inArray('sr_location', options.visibleCriteria) > -1))
					locationMultiSelect.parent().hide();

				locationMultiSelect.kendoMultiSelect({
					autoClose: false,
					close: autoSearch,
					filter: 'contains'
				});

				if (options.selectedCriteria && options.selectedCriteria.location)
					locationMultiSelect.data('kendoMultiSelect').value(options.selectedCriteria.location);

				//init kendo country multiselect
				countryMultiSelect.html(getOptionList(countries));

				if (!($.inArray('sr_country', options.visibleCriteria) > -1))
					countryMultiSelect.parent().hide();

				countryMultiSelect.kendoMultiSelect({
					autoClose: false,
					close: autoSearch,
					filter: 'contains'
				});

				if (options.selectedCriteria && options.selectedCriteria.country)
					countryMultiSelect.data('kendoMultiSelect').value(options.selectedCriteria.country);

				//init kendo country multiselect
				ouMultiSelect.html(getOptionList(ous));

				if (!($.inArray('sr_ou', options.visibleCriteria) > -1))
					ouMultiSelect.parent().hide();

				ouMultiSelect.kendoMultiSelect({
					autoClose: false,
					close: autoSearch,
					filter: 'contains'
				});

				if (options.selectedCriteria && options.selectedCriteria.ou)
					ouMultiSelect.data('kendoMultiSelect').value(options.selectedCriteria.ou);

				// Automatically search on "Return" key press
				$('#sr-widget-keyword', tempElement).on('keyup', function (e) {
					if (e.which === 13)
						searchJobs();
				});

				$('#sr-widget-form', tempElement)
					.on('submit', function (e) {
						searchJobs();

						return false;
					})
					.on('reset', function (e) {
						keywordTextBox.val(null);
						departmentMultiSelect.val(null);
						employmentTypeMultiSelect.val(null);
						jobFamilyMultiSelect.val(null);
						locationMultiSelect.val(null);
						countryMultiSelect.val(null);
						ouMultiSelect.val(null);

						kendoGrid.dataSource.filter([]);

						return false;
					});

				if (options.hideCriteria)
					$('#sr-widget-search-filters-container', tempElement).hide();

				searchJobs();
			}

			// ---------------------------------------------------------------------------------------------
			// Perform an AJAX call taking into account the user's browser (IE or modern).
			// This function returns a promise.
			function makeAjaxCall(queryUrl) {
				var deferred = $.Deferred();

				if (!('withCredentials' in new XMLHttpRequest()) && window.XDomainRequest) {
					if (window.XDomainRequest) {
						var xdr = new XDomainRequest();
						if (xdr) {
							xdr.onload = function () {
								// If the user is using IE, they get text back, not a JSON object
								deferred.resolve(jQuery.parseJSON(xdr.responseText));
							};
							xdr.onerror = function () {
								deferred.reject();
							};
							xdr.open('GET', queryUrl);
							xdr.send();
						}
					}
					else
						deferred.reject();
				}
				else
					deferred = $.ajax({
						type: 'GET',
						url: queryUrl,
						cache: false,
                        dataType: 'json',
                        headers: {
                            "accept-language": "en-GB"
                        }
					});

				return deferred.promise();
			}

			// ---------------------------------------------------------------------------------------------
			// Makes at least one AJAX call in order to retrieve the data from the remote servers.
			// The first call returns the first 100 items and also returns the total number 
			// of available items, which we're going to use in order to build an array of 
			// deferred objects which will be executed in parallel, to speed up the page load time.
			//
			// Returns a promise which contains the retrieved data.
			function getData() {
				var deferred = $.Deferred();

				var allData = [];

				var limit = 100;
				var offset = 0;

				var url = options.postingsUrl + (options.postingsUrl.indexOf('?') == -1 ? '?' : '&') + 'limit=' + limit.toString() + '&offset=' + offset.toString();

				// Retrieve the first batch of data along with the total number of items that can be retrieved.
				makeAjaxCall(url).then(function (data) {
					// Save the first batch of data.
					allData = allData.concat(data.content);

					// Create the promises that will be resolved in parallel.
					if (data.totalFound > limit) {
						var promisesToResolve = [];

						// Build the promises that we're going to execute in parallel.
						do {
							offset += limit;

							if (offset > data.totalFound)
								break;

							url = options.postingsUrl + (options.postingsUrl.indexOf('?') == -1 ? '?' : '&') + 'limit=' + limit.toString() + '&offset=' + offset.toString();

							promisesToResolve.push(makeAjaxCall(url));
						} while (offset > 0);

						// Now get the remaining of data, by executing in parallel all the promises we've just built.
						$.when.apply($, promisesToResolve).then(function () {
							var resolvedPromises = (arguments.length > 1) ? $.makeArray(arguments) : [arguments];

							// Add to our data array the values returned by all promises.
							$.each(resolvedPromises, function (index, data) {
								allData = allData.concat(data[0].content);
							});

							// Now we're ready to call the "processData" function.
							deferred.resolve(allData);
						}, function () {
							handleDataError();
							deferred.reject();
						});
					}
				}, function () {
					handleDataError();
					deferred.reject();
				});

				return deferred.promise();
			}

			// ---------------------------------------------------------------------------------------------
			// Function to be executed when all data has been fetched from the remote servers.
			function processData(data) {
				var rawJobs = [];
				var jobPositions = [];
				var speculativeJobPositions = [];

				function addJob(jobToAdd) {
					if (jobToAdd.sr_isSpeculativeJob === false && (options.showInternalJobs || !jobToAdd.sr_isInternal))
						jobPositions.push(jobToAdd);

					if (jobToAdd.sr_isSpeculativeJob === true && (options.showInternalJobs || !jobToAdd.sr_isInternal))
						speculativeJobPositions.push(jobToAdd);
				}

				rawJobs = $.map(data, function (item) {
					var country = ((item.location || {}).country || '').toUpperCase();

					item.sr_refNumber = item.refNumber;
					item.sr_jobTitle = item.name;
					item.sr_jobFamily = ($.grep(item.customField, function (e) {
						return e.fieldId === internalOptions.customFieldsIds.jobFamily;
					})[0] || {}).valueLabel;
					item.sr_location = item.location.city;
					item.sr_employmentType = item.typeOfEmployment.label;
					item.sr_hasReferal = ($.grep(item.customField, function (e) {
						return e.fieldId === internalOptions.customFieldsIds.hasReferral && e.valueLabel === 'Yes';
					})).length === 1;
					item.sr_isSpeculativeJob = $.grep(item.customField, function (e) {
						return e.fieldId === internalOptions.customFieldsIds.isSpeculativeJob && e.valueLabel === 'Yes';
					}).length === 1;
					item.sr_department = (item.department ? item.department.label : 'N/A'),
						item.sr_country = options.allCountries[country] || 'N/A';
					item.sr_language = item.language ? item.language.code.substring(0, 2).toLowerCase() : 'en';
					item.sr_isInternal = $.grep(item.customField, function (e) {
						return e.fieldId === internalOptions.customFieldsIds.isPrivateJob && e.valueLabel === 'Yes';
					}).length === 1;

					item.sr_ou = ($.grep(item.customField, function (e) {
						return e.fieldId === internalOptions.customFieldsIds.ou;
					})[0] || {}).valueLabel;

					return item;
				});

				for (var i = 0; i < rawJobs.length; i++) {
					var job = rawJobs[i];

					//EN language
					if (options.language === 'en') {
						//en jobs
						if (job.sr_language === 'en') {
							addJob(job);
						}
						else if (job.sr_language === 'fr' && $.grep(rawJobs, function (e) {
							return e.sr_language === 'en' && e.refNumber === job.refNumber;
						}).length === 0) {
							addJob(job);
						}
					}
					else if (options.language === 'fr') {
						//en jobs
						if (job.sr_language === 'fr') {
							addJob(job);
						}
						else if (job.sr_language === 'en' && $.grep(rawJobs, function (e) {
							return e.sr_language === 'fr' && e.refNumber === job.refNumber;
						}).length === 0) {
							addJob(job);
						}
					}
					else {
						//add job in selected language
						if (job.sr_language === options.language) {
							addJob(job);
						}
						else if (job.sr_language === 'en' && $.grep(rawJobs, function (e) {
							return e.sr_language === options.language && e.refNumber === job.refNumber;
						}).length === 0) {
							addJob(job);
						}
						else if (job.sr_language === 'fr' && $.grep(rawJobs, function (e) {
							return (e.sr_language === options.language || e.sr_language === 'en') && e.refNumber === job.refNumber;
						}).length === 0) {
							addJob(job);
						}
					}
				}

				if (options.filter) {
					//grid datasource
					var jobPositionsDataSource = new kendo.data.DataSource({
						data: jobPositions
					});

					jobPositionsDataSource.filter(options.filter);
					jobPositions = jobPositionsDataSource.view();
				}

				if (options.speculativeFilter) {
					//grid datasource
					var speculativeJobPositionsDataSource = new kendo.data.DataSource({
						data: speculativeJobPositions,
					});

					speculativeJobPositionsDataSource.filter(options.speculativeFilter);
					speculativeJobPositions = speculativeJobPositionsDataSource.view();
				}

				return {
					jobPositions: jobPositions,
					speculativeJobPositions: speculativeJobPositions
				}
			}

			// ---------------------------------------------------------------------------------------------
			// Function to be executed when the data retrieval fails.
			function handleDataError() {
				var errorTemplate = $('#sr-error-template').html();
				//$('#sr-error-template').html().replace(/(\r\n|\n|\r)/gm,"")
				//var errorTemplate = '';

				var tempElement = $("<div id='sr-widget-container' />");
				tempElement.html(kendo.template(errorTemplate)(options));
				placeWidgetInLocation(widgetLocation, tempElement);

			}

			// ---------------------------------------------------------------------------------------------
			function showDetails(id, animate, setHash) {
				var deferred = $.Deferred();
				var $widgetJobDescriptionContainer = $('#sr-widget-job-description-container', tempElement);

				var url = options.postingDetailsUrl.replace('#:id#', id.toString());
				makeAjaxCall(url).then(function (data) {
					display(data, setHash);
				});

				function display(position, setHash) {
					var search = window.location.hash.replace('#', '');
					var isRedirect = srWidget.parseQuery(search)['is-redirect'];

					if (isRedirect != null && (isRedirect === true || isRedirect === 'true'))
						options.detailsBackButtonVisible = false;

					if (setHash && options.useHashtagIdentifier)
						window.location.hash = 'sr-post-id=' + id.toString();

					position.options = options;
					position.postingPageUrl = options.postingsPageUrl.replace('#:id#', id.toString());
					position.applyButtonUrl = options.applyButtonUrl.replace('#:id#', id.toString());
					position.referAFriendButtonUrl = options.referAFriendButtonUrl.replace('#:id#', id.toString());

					var country = ((position.location || {}).country || '').toUpperCase();
					position.country = options.allCountries[country] || 'n/a';

					var template = options.detailsTemplate
						.replace(/#linkedInRedirectUrl#/g, options.linkedInRedirectUrl)
						.replace(/#facebookRedirectUrl#/g, options.facebookRedirectUrl)
						.replace(/#twitterRedirectUrl#/g, options.twitterRedirectUrl)
						.replace(/#mailRedirectUrl#/g, options.mailRedirectUrl);

					//############### Button events #############

					$widgetJobDescriptionContainer.off('click.sr_events');
					if (options.onApplyButtonClick !== null) {
						$widgetJobDescriptionContainer.on('click.sr_events', '.sr-widget-apply-button', function (e) {
							e.id = position.id;
							e.posting = position;
							options.onApplyButtonClick(e);
						});
					}

					if (options.onReferAFriendButtonClick !== null) {
						$widgetJobDescriptionContainer.on('click.sr_events', '.sr-widget-refer-button', function (e) {
							e.id = position.id;
							e.posting = position;
							options.onReferAFriendButtonClick(e);
						});
					}

					$widgetJobDescriptionContainer[0].innerHTML = kendo.template(template)(position);
					if (animate) {
						$widgetJobDescriptionContainer.show();

						$widgetJobDescriptionContainer.css('position', 'absolute');
						$widgetJobDescriptionContainer.stop().animate({
							top: $(window).scrollTop().toString() + 'px'
						}, 200, 'linear', function () {
							$widgetJobDescriptionContainer.css({
								top: '0px',
								position: 'relative'
							});
							$('html, body').scrollTop('0px');
							$('.sr-widget-search-filters-container', tempElement).hide();
							$('.sr-widget-grid-results-container', tempElement).hide();
						});
					}
					else {
						$widgetJobDescriptionContainer.css({
							top: '0px',
							position: 'relative'
						});
						$widgetJobDescriptionContainer.show();
						$('.sr-widget-search-filters-container', tempElement).hide();
						$('.sr-widget-grid-results-container', tempElement).hide();
					}

					$widgetJobDescriptionContainer.data('posting', position);

					deferred.resolve(false);
				}

				return deferred.promise();
			}

			// ---------------------------------------------------------------------------------------------
			function configureGridAndGetData() {
				getData().then(function (data) {
					var processedData = processData(data);

					var gridDataSource = new kendo.data.DataSource({
						data: processedData.jobPositions,
						schema: {
							model: {
								id: 'id'
							}
						},
						pageSize: options.postingsGridPageSize
					});

					var grid = configureGrid(processedData.speculativeJobPositions);

					grid.setDataSource(gridDataSource);

					configureFilters(processedData.jobPositions, grid);

					displayGrid();
				});
			}

			// Populate the grid with the jobs.
			configureGridAndGetData();
		}

		// ---------------------------------------------------------------------------------------------
		// Insert a loading spinner that is shown until the widget is completelly initialized
		function addLoader() {
			var container = document.querySelector(options.widgetContainerSelector
				? options.widgetContainerSelector
				: '[data-sr-widget]');

			var loader = document.createElement('div');
			loader.id = 'sr-widget-loading';
			loader.className = 'loader';

			if (!container) {
				let scripts = document.querySelectorAll('script');
				for (var i = 0; i < scripts.length; i++) {
					var script = scripts[i];
					if (!!~script.innerHTML.indexOf('srWidget(')) {
						script.parentNode.insertBefore(loader, script.nextSibling);
						break;
					}
				}
			}
			else
				container.appendChild(loader);
		}

		// ---------------------------------------------------------------------------------------------
		function createWebWorker(baseUrl) {
			// Use a web worker to download & preapare the data in a separate thread
			webWorkerPromise = new Promise(function (resolve, reject) {
				var worker = new Worker(baseUrl + 'worker.js');

				worker.onmessage = function (event) {
					resolve(event.data);
					worker.terminate();
				}

				worker.postMessage({
					'queryUrl': options.postingsUrl + (!~options.postingsUrl.indexOf('?') ? '?' : '&')
				});
			});
		}

		// ---------------------------------------------------------------------------------------------
		// Method that makes sure all necessary files are loaded before configuring the widget.
		// If RequireJs is available, have it call the setup method of our widget, 
		// otherwise get RequireJs first and once retrieved, configure our widget.
		var initialize = function () {
			addLoader();

			var paths = getWidgetPaths();

			// Sadly IE11 doesn't understand the native Promise...
			// createWebWorker(paths.widgetJsPath);

			if (typeof requirejs !== 'undefined')
				loadWidget(paths.widgetCssPath, paths.widgetJsPath, configureWidget);
			else
				loadScript(paths.widgetJsPath + 'require.min.js', function () {
					loadWidget(paths.widgetCssPath, paths.widgetJsPath, configureWidget);
				});

		};

		// Initialize the widget.
		initialize();
	};

	// ---------------------------------------------------------------------------------------------
	// Attach to our widget a function that returns an object 
	// which contains an URL's query parameters.
	widget.parseQuery = function (search) {
		var args = search.split('&');

		var argsParsed = {
		};

		for (var i = 0; i < args.length; i++) {
			var arg = args[i];

			if (-1 === arg.indexOf('=')) {
				argsParsed[decodeURIComponent(arg).trim()] = true;
			}
			else {
				var kvp = arg.split('=');

				var key = decodeURIComponent(kvp[0]).trim();
				argsParsed[key] = decodeURIComponent(kvp[1]).trim();
			}
		}

		return argsParsed;
	};

	// ---------------------------------------------------------------------------------------------
	// Attach to our widget a function that extracts a YouTube's video identifier.
	widget.extractYouTubeId = function (url) {
		var videoId = url.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
		if (videoId != null)

			return videoId[1];
		else
			console.log('The youtube url is not valid.');
	};

	return widget;
})(window);
